const angular = require('angular');
const app = angular.module('learn-services');

/**
 * Constant values and global singleton services for the learn app i18n
 * @argument {$translate} $translate The angular-translate service
 */
app.factory('i18n', ['$translate', function($translate) {

  var service = {
    version: '1.0',
    ENGLISH: 'en',
    SPANISH: 'es_419',
    DEUTSCH: 'de',
    rightToLeft: ['ar'],
    language_codes: ['en', 'ar', 'zh_cn', 'zh_tw', 'fr','fr_CA', 'de', 'hi_in', 'id', 'it', 'ja', 'ko', 'pl', 'pt_br', 'ru', 'es_419', 'es_es', 'sv_se', 'th', 'vi', 'cs', 'da', 'nl', 'fi', 'no'],
    language: function(language) {
      var chosen = null;
      var current = $translate.use();
      if (!language) {
        language = 'english';
      }
      language = (language + '').toLowerCase();
      switch (language) {
        case 'english':
        case 'eng':
        case 'en':
          chosen = service.ENGLISH;
          break;
        case 'spanish':
        case 'spa':
        case 'sp':
        case 'es':
        case 'es_419':
          chosen = service.SPANISH;
          break;
        default:
          if (service.language_codes.indexOf(language) !== -1) {
            chosen = language;
            break;
          }
          chosen = service.ENGLISH;
          break;
      }
      if (chosen && current !== chosen) {
        if (service.rightToLeft.indexOf(chosen) !== -1) {
          document.body.classList.add("rtlSupport");
        } else {
          document.body.classList.remove("rtlSupport");
        }

        $translate.use(chosen);
      }
    },
    translate: $translate,
    localize_categories: function(categories) {
      if (!categories) {
        return categories;
      }
      var language = service.translate.use();
      if (language === service.ENGLISH) {
        //console.log('Will not localize categories - English is the current language');
        return categories;
      }

      language = language.toLowerCase();
      language = language + ':';

      for (var i = 0, len = categories.length; i < len; i++) {
        if (!categories[i].localized_names || categories[i].localized_names.indexOf(language) === -1) {
          continue;
        }

        var items = categories[i].localized_names.split(language);
        if (!items[1]) {
          continue;
        }
        var secondary = items[1].split(',');
        if (!secondary[0]) {
          continue;
        }

        categories[i].name = secondary[0];
        categories[i].label = secondary[0];
      }

      return categories;
    },
    language_codes_surveyjs: {
      'ar': 'ar',
      'cs': 'cs',
      'da': 'da',
      'de': 'de',
      'es_la': 'es',
      'es_es': 'es',
      'fi': 'fi',
      'fr': 'fr',
      'fr_CA': 'fr',
      'hi_in': null,
      'id': 'id',
      'it': 'it',
      'ja': 'ja',
      'ko': 'ko',
      'nl': 'nl',
      'no': 'no',
      'pl': 'pl',
      'pt_br': 'pt',
      'ru': 'ru',
      'sv_se': 'sv',
      'th': null,
      'vi': null,
      'zh_cn': 'zh-cn',
      'zh_tw': 'zh-tw',
    }
  };

  return service;

}]);
